var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 16.3257C1.5 11.6313 5.30558 7.82568 10 7.82568V7.82568C14.6944 7.82568 18.5 11.6313 18.5 16.3257V17.1117C18.5 18.5156 17.3619 19.6538 15.9579 19.6538H4.0421C2.63814 19.6538 1.5 18.5156 1.5 17.1117V16.3257Z",
    fill: "#888888"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.27715 9.24568C5.18231 9.16895 6.97493 8.30567 7.16604 8.30566V11.6243H12.8672V8.30566C13.0583 8.30567 14.8509 9.16895 14.7561 9.24568V11.7021C15.6086 11.9452 16.2329 12.73 16.2329 13.6606V16.5354H3.95508V13.6606C3.95508 12.7873 4.50483 12.0424 5.27715 11.753V9.24568Z",
    fill: "#F1F1F1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 4.55005,
    r: 4.25,
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/contacts.616824a866214cbd94da98e01f027837.svg";
export { ForwardRef as ReactComponent };